"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var systemMonitoringRouter = {
  type: 1,
  path: '/sms-system-monitoring',
  component: _layout.default,
  redirect: '/table/system-daily-log',
  name: '',
  meta: {
    title: 'monitorSystem',
    icon: 'g-system'
  },
  children: [{
    type: 2,
    path: 'system-daily-log',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-monitoring-management/system-daily-log'));
      });
    },
    name: 'log:view',
    meta: {
      title: 'monitorDaily'
    },
    children: [{
      path: 'list',
      name: 'log:list',
      hidden: true
    }, {
      path: 'export',
      name: 'log:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'login-log',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-monitoring-management/login-log'));
      });
    },
    name: 'loginLog:view',
    meta: {
      title: 'monitorLogin'
    },
    children: [{
      path: 'export',
      name: 'loginLog:export',
      hidden: true
    }]
  }]
};
var _default = systemMonitoringRouter;
exports.default = _default;